import { Message, MessageBox } from "element-ui";
import { CreatedUrl } from "@/class";
export class OssUpload extends CreatedUrl {
  constructor(
    multiple = true,
    limit = 2,
    mode = "string",
    keyObject = {},
    isHide = false,
    accept = ""
  ) {
    super();
    this.el = {
      fileList: [],
      modeArray: [],
      hide: false,
      hideStyle: isHide ? "unset" : "inline-block",
      multiple: multiple,
      multipleNum: 0,
      limit: limit, //允许上传文件的最大数量
      maxSize: 0.2,
      size: 1024 * 1024 * this.maxSize,
      mode: mode,
      isDelInfo: false,
      disabled:false,//是否禁用
      accept: accept, //文件格式
      acceptObject: {
        //真实校验文件格式
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        doc: "application/msword",
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        xls: "application/vnd.ms-excel",
        pdf: "application/pdf",
        mp4: "video/mp4",
        zip: "application/zip,application/x-zip-compressed",
        rar: "application/x-rar,application/x-compressed",
        ai: "application/postscript",
          '7z': "application/x-7z-compressed",
         pptx:"application/vnd.openxmlformats-officedocument.presentationml.presentation"
      },
      keyObject: keyObject,
      successResult: undefined,
      fileUrl: [],
      fileMode: undefined,
      fileName: undefined,
      emit: () => { },//上传成功触发emit('onSuccess')
      emitValue: () => { },//双向绑定emit('input')
      emitAllSuccess: () => { },//当multiple = true 时，完成所以上传，才会触发emit('onAllSuccess')
      setStyleHide: () => {
        const { el } = this;
        console.log('el.disabled',el.disabled)
        if(el.disabled){
          el.hideStyle = "unset";
          return false
        }
        if (el.limit === el.fileList.length) {
          el.hideStyle = "unset";
        } else {
          el.hideStyle = "inline-block";
        }
      },
    };
    this.headers = {
      Authorization: window.sessionStorage.getItem("token"),
      ClientId: "admin-app",
    };
    this.host = "http://alihuoban-web.pulaien.shop/api/";
    this.action = this.host + "cmUser/message/uploadFile";
    this.formData = { modular: "shopmall", type: undefined };
    this.url;
    this.allUrl = [];
    this.isBeforeDel = false //上传之前如果类型不正确，同样会触发beforeRemove，增加一个开关，区分是手动触发还是自动触发
    this.updateFiles = () => { }// 重写
    this.beforeUpload = async (file) => {
      // console.log('beforeUpload',file)
      // //上传前验证文件
      const { el } = this;
      const { name, type, size } = file;
      console.log("beforeUpload--", file);
      return new Promise(async (resolve, reject) => {
        if (size > el.size) {
          Message.error(`文件超过${el.size / 1024 / 1024} MB，无法上传`);
          this.isBeforeDel = true
          reject(false)
        }
        try {
          let idx = name.lastIndexOf(".");
          if (idx > -1) {
            let EXT = name.slice(idx).toLowerCase();
            let key = EXT.slice(1);
            if (el.accept.includes(EXT) && el.acceptObject[key].includes(type)) {
              console.log('---beforeUpload---true')
              this.isBeforeDel = false
              resolve(true)
            } else {
              Message.error("文件类型不匹配，无法上传");
              this.isBeforeDel = true
              reject(false);
            }
          }
        } catch (err) {
          //扩展名未加入到对象,el.acceptObject[key] 为undefined，el.acceptObject[key].includes(type)
          Message.error("文件类型不匹配，无法上传");
          this.isBeforeDel = true
          reject(false)
        }
      })

    };
    this.handlePreview = (uploadFile) => {
      //点击文件列表中已上传的文件时的钩子
    };
    this.removeFile = (fileUrl) => { }
    this.handleRemove = (uploadFile) => {
      console.log('handleRemove', uploadFile)
      //文件列表移除文件时的钩子
      const data = uploadFile?.response?.data || uploadFile
      const url = data.filePath || data.url
      const { el } = this;
      for (let i in el.fileList) {
        let item = el.fileList[i];
        if (item.url === url) {
          this.el.fileList.splice(i, 1);
          this.removeFile(url)
          break;
        }
      }
      this.modeString();
      this.modeObject();
      this.modeArray();
      // this.el.hideStyle = 'inline-block'
    };
    this.beforeRemove = (e) => {
      console.log('beforeRemove', e)
      if (this.el.isDelInfo && !this.isBeforeDel) {
        return new Promise((resolve, reject) => {
          MessageBox.confirm('此操作将删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            Message({
              type: 'success',
              message: '删除成功!'
            });
            resolve(true)
          }).catch(() => {
            Message({
              type: 'info',
              message: '已取消删除'
            });
            reject(false)
          });
        })
      }

      //删除文件之前的钩子，参数为上传的文件和文件列表， 若返回 false 或者返回 Promise 且被 reject，则停止删除。
    };
    this.handleExceed = (e) => {
      //当超出限制时，执行的钩子函数
      const nowNum = Number(this.el.fileList.length) + Number(e.length);
      if (nowNum > this.el.limit) {
        Message.error("最大上传数量不超过" + this.el.limit);
      }
    };
    this.onSuccess = (result, uploadFile) => {
      console.log("on-success", uploadFile);
      const data = uploadFile?.response?.data || uploadFile
      this.el.successResult = data;
      this.el.fileList.push({
        url: data.filePath || data.url,
        name: data.fileName || data.name,
      });
      if (!this.el.multiple) {
        //在多选状态时，el不可修改fileList，
        //非多选状态时，才可修改。。由于mp4是自定义预览，需要读取fileList文件，即需要修改fileList，
        //最终结论为：自定义预览的mp4,不可使用多选。。而其它非自定义预览的jpg等，可使用多选状态
        this.updateFiles()
      }

      this.modeString();
      this.modeObject();
      this.modeArray();
      this.el.emit();
    };
    this.modeString = () => {
      const { el } = this;
      if (el.mode === "string") {
        let urlList = [];
        let nameList = [];
        el.fileList.forEach((item) => {
          urlList.push(item.url);
          nameList.push(item.name);
        });
        el.fileMode = urlList.toString(",");
        el.fileName = nameList.toString(",");
        el.emitValue();
      }
    };
    this.modeObject = () => {
      const { el } = this;
      if (el.mode === "object") {
        let obj = {};
        if (el.fileList.length > 0) {
          let idx = el.fileList.length - 1;
          const item = el.fileList[idx];
          for (let keys in el.keyObject) {
            let keyValue = el.keyObject[keys];
            if (!["name", "url"].includes(keys)) {
              obj[keys] = item[keyValue];
            }
            if (keys === "name") {
              obj[keyValue] = item.name;
            }
            if (keys === "url") {
              obj[keyValue] = item.url;
            }
          }
          el.fileMode = { ...obj };
        } else {
          el.fileMode = {};
        }

        el.emitValue();
      }
    };
    this.modeArray = () => {
      const { el } = this;
      if (el.mode === "array") {
        let array = [];
        for (let i in el.fileList) {
          let response = el.fileList[i];
          let obj = {};
          for (let keys in el.keyObject) {
            let keyValue = el.keyObject[keys];
            if (!["name", "url"].includes(keys)) {
              obj[keys] = response[keyValue];
            }
            if (keys === "name") {
              obj[keyValue] = response.name;
            }
            if (keys === "url") {
              obj[keyValue] = response.url;
            }
          }
          array.push({ ...obj });
        }
        el.fileMode = array;
        el.emitValue();
      }
    };
    this.onError = (e) => {
      //'上传请求失败，请稍后再试!'
      Message.error("上传请求失败，请稍后再试!");
    };
  }
  viewString = (modelValue, fileName) => {
    const { el } = this;
    if (el.mode === "string") {
      try {
        let urlList = modelValue?.split(",") || [modelValue];
        let nameList = fileName?.split(",") || [fileName];
        console.log("urlList", urlList);
        urlList.forEach((item, index) => {
          const uid = new Date().getTime() + index;
          el.fileList.push({
            url: item,
            name: nameList[index] || `文件${index + 1}`,
            uid: uid,
          });
        });
      } catch (err) {
        const uid = new Date().getTime();
        el.fileList.push({
          url: modelValue,
          name: fileName || `文件${1}`,
          uid: uid,
        });
      }
      el.setStyleHide();
    }
  };
  viewObject = (modelValue) => {
    const { el } = this;
    console.log("mode", el.mode);
    if (el.mode === "object") {
      let item = modelValue;
      let obj = {};
      for (let keys in el.keyObject) {
        let keyValue = el.keyObject[keys];
        console.log("item[keyValue]", item[keyValue]);
        if (keys === "name") {
          obj.name = item[keyValue];
        }
        if (keys === "url") {
          obj.url = item[keyValue];
        }
      }
      el.fileList.push({ ...obj });
      el.setStyleHide();
    }
  };
  viewArray = (modelValue) => {
    const { el } = this;
    if (el.mode === "array") {
      modelValue.forEach((item, index) => {
        let obj = {};
        for (let keys in el.keyObject) {
          let keyValue = el.keyObject[keys];
          if (keys === "name") {
            obj.name = item[keyValue];
          }
          if (keys === "url") {
            obj.url = item[keyValue];
          }
        }
        el.fileList.push({ ...obj });
      });
      el.setStyleHide();
    }
  };
}
